import React, {
  forwardRef,
  useCallback,
  useEffect,
  useImperativeHandle,
  useState,
} from "react";
import { Button, Col, Modal, Row, Select } from "antd";
import { useLocation, useNavigate } from "react-router-dom";
import { toastError, toastSuccess } from "helpers/toasters";
import PrimaryButton from "modules/SubComponents/Buttons/PrimaryButton";
import SecondaryButton from "modules/SubComponents/Buttons/SecondaryButton";
import { deleteSeason, getAllSeasonsDependsOnSeries } from "Network";
import ROUTES from "constants/NewRoutes";
import { dropdownStyle } from "helpers/helpfulFunctions";
import { DeleteFilled, DeleteOutlined } from "@ant-design/icons";

const EditModal = forwardRef(
  (
    {
      editModalVisible,
      SubHeader,
      primaryBtnName,
      secondaryBtnName,
      editOnCancel,
      selectedHeaderId,
      genreId,
      genreName,
      setHeaderId,
      setIsDeleted,
      isDeleted,
      setEditModalVisible,
    },
    ref
  ) => {
    console.log("🚀 ~ selectedHeaderId:", selectedHeaderId);
    const [seasonsDependsOnHeaderId, setSeasonsDependsOnHeaderId] = useState(
      []
    );
    const [selectedSeasonId, setSelectedSeasonId] = useState(null);
    const [seasonError, setSeasonError] = useState(false);
    const [disableMe, setDisableMe] = useState(true);
    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();
    const location = useLocation();

    const isAnime = location.pathname === ROUTES.ANIME;
    const isKnowIt = location.pathname === ROUTES.TVPROGRAMS;

    useEffect(() => {
      setSeasonError(false);
    }, [editModalVisible]);

    // const getAllSeasons = useCallback(() => {}, []);

    useEffect(() => {
      if (selectedHeaderId) {
        console.log("CALL SEASONS AGAIN");
        getAllSeasonsDependsOnSeries(
          { videoHeaderId: selectedHeaderId },
          (success) => {
            if (success?.isSuccess) {
              setSeasonsDependsOnHeaderId(success.data);
              // if (success.data.length === 0) {
              //   // setEditModalVisible(false);
              // } else {
              //   setSeasonsDependsOnHeaderId(success.data);
              // }
            }
          },
          (fail) => {
            if (fail?.data) {
              toastError(fail.data.err_msg);
            } else {
              toastError();
            }
          }
        );
      }
    }, [selectedHeaderId, isDeleted, seasonsDependsOnHeaderId.length]);

    // Expose endEditModal to the parent component
    useImperativeHandle(ref, () => ({
      closeModal: endEditModal,
    }));

    const handleSelectSeason = (seasonId) => {
      const season = seasonsDependsOnHeaderId?.find(
        (season) => season.id === seasonId
      );

      const seasonIndex = season?.index;

      if (seasonIndex === seasonsDependsOnHeaderId.length) {
        console.log("HEEEEE");
        // Last season in episode
        setDisableMe(false);
      } else {
        setDisableMe(true);
      }

      if (seasonId?.length > 0) {
        setSelectedSeasonId(seasonId);
        setSeasonError(false);
      }
    };

    function endEditModal() {
      setSeasonError(false);
      setDisableMe(true);
      setSelectedSeasonId(null);
      setHeaderId(null);
    }

    const goToEditHeaderData = () => {
      if (selectedSeasonId === null) {
        setSeasonError(true);
      } else {
        setSeasonError(false);
        const state = {
          selectedHeaderId,
          selectedSeasonId,
          genreId,
          seasonsDependsOnHeaderId,
          genreName,
          isSeries: true,
        };
        if (isAnime) {
          navigate(`${ROUTES.EDITTVSHOW}?anime=true`, {
            state,
          });
        } else if (isKnowIt) {
          navigate(`${ROUTES.EDITTVSHOW}?knowIt=true`, {
            state,
          });
        } else {
          navigate(ROUTES.EDITTVSHOW, {
            state,
          });
        }
      }
    };

    const handleDeleteSeason = () => {
      setLoading(true);
      deleteSeason(
        { videoHeaderId: selectedHeaderId, seasonId: selectedSeasonId },
        (success) => {
          if (success.isSuccess) {
            setSelectedSeasonId(null);
            setDisableMe(true);
            setIsDeleted((prev) => !prev);
            toastSuccess(success.message);
            setLoading(false);
          }
        },
        (error) => {}
      );
    };

    console.log(selectedHeaderId);

    return (
      <Modal
        open={editModalVisible}
        title={SubHeader}
        className="msg-modal text-center"
        footer={[]}
        closable={false}
      >
        <Row className="mrg-ys-50 mrg-ye-100">
          <Col span={24} className="mrg-ye-20">
            <div className="new-category  ">
              <label className="title-style">Choose Season</label>
              <Select
                dropdownStyle={dropdownStyle}
                onChange={(seasonId) => handleSelectSeason(seasonId)}
                className="search__searchField py-1 wd-100"
                value={selectedSeasonId}
              >
                {seasonsDependsOnHeaderId?.map(({ id, name }, index) => {
                  return (
                    <Select.Option key={index} value={id}>
                      {name}
                    </Select.Option>
                  );
                })}
              </Select>
              {seasonError && (
                <div className="episode-errors">Please select season!</div>
              )}
            </div>
          </Col>
          {!disableMe && (
            <div className="text-danger">
              Deleting this season will delete all of its related episodes!
            </div>
          )}
        </Row>
        <div className="d-flex justify-content-center gap-2">
          <SecondaryButton
            buttonName={secondaryBtnName}
            onClick={editOnCancel}
          />
          <PrimaryButton
            buttonName={primaryBtnName}
            onClick={goToEditHeaderData}
          />
          <Button
            size="large"
            style={{
              borderRadius: "12px",
              width: "129px",
              height: "40px",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
            disabled={disableMe}
            type={"danger"}
            onClick={handleDeleteSeason}
            icon={<DeleteOutlined />}
            loading={loading}
          >
            Delete
          </Button>
        </div>
      </Modal>
    );
  }
);

export default EditModal;
